<div class="sidebar-header">
  <img [src]="logo" alt="Logo" width="25" />
</div>
<div class="sidebar-options">
  @for (item of portal; track item.id) {
  <div class="sidebar-option" [class.active]="selected.id === item.id"
    (click)="setSelected(item.id, false)">
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
      <path fill="currentColor" fill-rule="evenodd"
        [attr.d]="item.icono"
        clip-rule="evenodd" />
    </svg>
    <span>{{ item.descripcion }}</span>
  </div>
  }
</div>